import Select, { components } from 'react-select';
import { FC } from 'react';
import { Image } from 'components/Image';
import { ENV_CONFIG } from 'config/environment';
import { sameId } from 'helpers/utils';

interface Props {
  type: 'recipient' | 'partner';
  label: string;
  getOptionsFromAPI: (search_str: string) => void;
  data: any[];
  optionsSelected: any[];
  setOptionsSelected: (options: any[]) => void;
  removeItemOption: (option: any) => void;
  options: { value: string; label: string }[];
}

export const SearchWithOptions: FC<Props> = ({
  type,
  label,
  getOptionsFromAPI,
  data,
  optionsSelected,
  setOptionsSelected,
  removeItemOption,
  options,
}) => {
  let timeoutId;
  const handleSearchOptions = (search_str: string) => {
    if (search_str.length > 0) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(function () {
        getOptionsFromAPI(search_str);
      }, 500);
    }
  };

  const CustomOption = props => {
    const optionIdProp = type === 'recipient' ? 'recipient_id' : 'client_id';
    // resource_id is stored as a string in the polymorphic admin_user table; the resource's own client_id/recipient_id is numeric
    const option = data?.find(item => sameId(item[optionIdProp], props.data.value));

    return (
      <components.Option {...props}>
        {type === 'recipient' ? (
          <div className="row space-between">
            <div className="row">
              <Image
                src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${option?.misc_ids?.photo_id}.jpg`}
                alt={props.data.label}
                className="search-image"
                fallbackImgType="candidate_square"
              />
              <div className="grid">
                <span className="body-small-text">{props.data.label}</span>
                <span className="body-small-text">{option?.race?.election?.display_info}</span>
              </div>
            </div>
            <span className="search-impact">{option?.impact_score}</span>
          </div>
        ) : (
          <div className="row">
            <span className="oath-bodysmall inkBlue">{props.data.label}</span>
            {option?.subscription_level && (
              <span className="oath-bodysmall inkBlue"> ({option.subscription_level})</span>
            )}
          </div>
        )}
      </components.Option>
    );
  };

  return (
    <>
      <label htmlFor={`${type}-input`}>{label}</label>
      <Select
        id={`${type}-input`}
        className="react-select success"
        classNamePrefix="react-select"
        placeholder="Search"
        name={`${type}-input`}
        isMulti
        isSearchable
        isClearable={false}
        value={optionsSelected}
        onChange={setOptionsSelected}
        onInputChange={handleSearchOptions}
        onKeyDown={e => {
          if (e.key === 'Backspace' && !e.target.value) {
            e.preventDefault();
          }
        }}
        options={options}
        components={{ Option: CustomOption }}
      />
      {optionsSelected?.length > 0 && (
        <div className="row input-item-list">
          {optionsSelected?.map(option => (
            <div className="input-item" key={option.value} onClick={() => removeItemOption(option)}>
              <span className="utility-text" key={option.value}>
                {option.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
